import { BreakConfigurationsDocument, BreakConfigurationsQuery } from 'generated/resources/graphql'
import _ from 'lodash'

import { useQuery } from 'modules/core/hooks/useQuery'

export type BreakConfiguration =
  BreakConfigurationsQuery['timeSettings']['breakConfigurationsConnection']['nodes'][number]

export const useBreakConfigurationsByIds = (timeSettingsBreakConfigurationIds: number[]) => {
  const { loading, data, refetch } = useQuery(BreakConfigurationsDocument, {
    variables: { timeSettingsBreakConfigurationIds },
    skip: timeSettingsBreakConfigurationIds.length === 0,
  })

  const breakConfigurations = data?.timeSettings.breakConfigurationsConnection.nodes || []
  const breakConfigurationsByIds: Record<number, BreakConfiguration> = _.keyBy(
    breakConfigurations,
    (breakConfiguration) => breakConfiguration.id
  )

  return {
    loading,
    breakConfigurationsByIds,
    refetch,
  }
}
